'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  font-size: 32pt;\n  margin-top: -10px;\n  font-family: ', ';\n  color: ', ';\n'], ['\n  font-size: 32pt;\n  margin-top: -10px;\n  font-family: ', ';\n  color: ', ';\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _theme = require('@hixme-ui/theme');

var _theme2 = _interopRequireDefault(_theme);

var _themeProps = require('@hixme-ui/theme-props');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StyledDollars = _styledComponents2.default.span(_templateObject, _theme2.default.fontFamily.bolder, function (props) {
  return (0, _themeProps.getTextColor)(props);
});

exports.default = StyledDollars;
//# sourceMappingURL=StyledDollars.js.map


//////////////////
// WEBPACK FOOTER
// ../price/lib/StyledDollars.js
// module id = 669
// module chunks = 0